import config from '../config';

export interface PlatformStats {
  total_users: number;
  users_with_preferences: number;
  users_without_preferences: number;
  dietary_preferences: {
    [key: string]: number;
  };
}

export const fetchPlatformStats = async (): Promise<PlatformStats> => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/api/platform-stats`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch platform stats: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching platform stats:', error);
    throw error;
  }
};
